import { inject, InjectionToken } from '@angular/core';

export interface EnvironmentData {
  production: boolean;
  enabledNamespaces: string[];
  apiUrl: string;
  appUrl: string;
  publicUrl: string;
  bookingUrl?: string;
  envName: string;
  sentryEnv: string;
  googleClientId: string;
  googleMapId: string;
  zoomClientId: string;
  buildVersion: string;
  stripeId: string;
  domain: string;
  bookingApp?: boolean;
  facebookAppId?: string;
  tolgeeApiUrl?: string;
  tolgeeApiKey?: string;
  tolgeeProjectId?: string;
}

// eslint-disable-next-line no-untranslated-string/no-untranslated-string
export const EnvironmentToken = new InjectionToken<EnvironmentData>('EnvironmentToken');

export function injectEnvironment() {
  return inject(EnvironmentToken);
}

export function provideEnvironment(data: EnvironmentData) {
  return {
    provide: EnvironmentToken,
    useValue: data,
  };
}
